export default __webpack_public_path__ + "static/media/userCircle.8d07b650.png";